import React, { useState, useEffect, useContext } from 'react';
import authAPI from '../api/auth';
import AuthContext from './authContext';
import { AuthService } from '../HttpService/AuthService';
import Cookies from 'js-cookie';

// export const AuthProvider = ({ children }) => {
//     const [user, setUser] = useState(null);

//     useEffect(() => {
//         const currentUser = authAPI.getUserInfo()
//         setUser(currentUser)
//     }, []);

//     return (
//         <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>
//     );
// };



const initialState = {
    isLoggedIn: false,
    isLoginPending: false,
    loginError: null,
}

const dataUser = {
    // id: 2,
    // username: "john.smith",
    // email: "john.smith@idom.com",
    // roles: [
    //     "COORDINATOR"
    // ],
    // accessToken: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJqb2huLnNtaXRoIiwiaWF0IjoxNjYyNTExNzM3LCJleHAiOjE2NjI1Mjk3Mzd9.BnTZNgncxbkwZlHacUJriTL5cH4yXkhG7apj16UPvA30lx7cVvMY41AvwrdnNbukNVdD8W569Ht424EPXGpuMA",
    // tokenType: "Bearer"
    
    id: 1,
    username: "john.doe",
    email: "john.doe@idom.com",
    roles: [
        "REGIONALUSER"
    ],
    accessToken: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJqb2huLmRvZSIsImlhdCI6MTY2MjUxMTk3MywiZXhwIjoxNjYyNTI5OTczfQ.LG_xm1Id5v2DxiyAdqIGCPZISmjAWwrL1TQvEPSqlg4grWyhsc18OfEZv-dSaaqSByXobU7rO2-8GEqbuzFLEA",
    tokenType: "Bearer"

    // id: 3,
    // username: "adam.smith",
    // email: "adam.smith@idom.com",
    // roles: [
    //     "ADMIN"
    // ],
    // accessToken: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZGFtLnNtaXRoIiwiaWF0IjoxNjYyNTEyMDU1LCJleHAiOjE2NjI1MzAwNTV9.4WmPYLpHvgdGhQVc0kOTdfAyhZONhx-clk6KuK0405sZGYdaNeu4C-ruX1OHu_pfkD0r_cvU5qMdPJlFavy6tw",
    // tokenType: "Bearer"
}

export const ContextProvider = props => {
    const [state, setState] = useState(initialState);
    const [user, setUser] = useState(dataUser);

    const setLoginPending = (isLoginPending) => setState({ isLoginPending });
    const setLoginSuccess = (isLoggedIn) => setState({ isLoggedIn });
    const setLoginError = (loginError) => setState({ loginError });

    const login = async (email, password) => {
        setLoginPending(true);
        setLoginSuccess(false);
        setLoginError(null);

        const res = await new AuthService("auth/signin").signIn({ username: email, password });
        setLoginPending(false);
        //console.log("results", res);
        if (res != null && res.status == 200) {
            res.data.permissions = res.data.rolePermissions;
            res.data.regionalPartner =  res.data.regionalPartners;

            setUser(res.data)
            let data = res.data;
            //console.log("user data", res.data);
            Cookies.set('token', res.data.token);
            window.localStorage.setItem('user', JSON.stringify(data));
            setLoginSuccess(true);
            // console.log("set results", state.userDetails.username);
        } else {
            console.log("res.status: ", res.status); //Este console.log cambia el proceso de ejecución y hace que nunca salte "Invalid credentials"
            setLoginError("Invalid Credentials");
        }
        // fetchLogin(email, password, error => {
        //     setLoginPending(false);

        //     if (!error) {
        //         setLoginSuccess(true);
        //     } else {
        //         setLoginError(error);
        //     }
        // })

        // const session = new ApplicationSession({
        //     clientId: 'm2OdcCcrnVqsV3SN',
        //     clientSecret: '83e46a7c8ffd4216bef702d07f177f09',
        //     duration: 1440
        // });
        // session.getToken("https://www.arcgis.com/sharing/rest/oauth2/token")
        // .then(function(response) {
        //     ArcGISIdentityManager.fromToken({
        //         token: response, //Token representing an ArcGIS Identity from performing oAuth 2.0
        //       }).then((authentication) => {
        //         // searchUsers({q: "Civil_Visor", authentication}).then((response) => {
        //         //     console.log(response);
        //         //   })
        //             // getUser("fjimenezor", { portal: "https://fri2cehnehvbcupw.maps.arcgis.com/sharing/rest" })
        //             // .then((response)=>{
        //             //     console.log(response);
        //             // });
        //             searchUsers({ q: 'Civil_Visor', authentication })
        //             .then((response) => {
        //                 console.log(response);
        //               }) // response.total => 355
        //       })
            
        // }).catch(function(error) {
        //     console.log(error)
        // });

        // const session = ApplicationCredentialsManager.fromCredentials({
        //     clientId: "m2OdcCcrnVqsV3SN",
        //     clientSecret: "83e46a7c8ffd4216bef702d07f177f09",
        //     //portal: "https://fri2cehnehvbcupw.maps.arcgis.com/sharing/rest"
        //   })
        // session.getToken("https://www.arcgis.com/sharing/rest/oauth2/token")
        // .then(function(response) {
        //     ArcGISIdentityManager.fromToken({
        //         token: response, //Token representing an ArcGIS Identity from performing oAuth 2.0
        //       }).then((authentication) => {
        //         // searchUsers({q: "Civil_Visor", authentication}).then((response) => {
        //         //     console.log(response);
        //         //   })
        //             // getUser("fjimenezor", { portal: "https://fri2cehnehvbcupw.maps.arcgis.com/sharing/rest" })
        //             // .then((response)=>{
        //             //     console.log(response);
        //             // });
        //             // searchUsers({ q: 'Civil_Visor', authentication })
        //             // .then((response) => {
        //             //     console.log(response);
        //             //   }) // response.total => 355
        //             authentication.getUser()
        //             .then((response) => {
        //                 console.log(response);
        //             })
        //       })
            
        // }).catch(function(error) {
        //     console.log(error)
        // });

        // getUser("Civil_Visor", { portal: "https://fri2cehnehvbcupw.maps.arcgis.com/sharing/rest" })
        //             .then((response)=>{
        //                 console.log(response);
        //             });

        // parameters = urllib.urlencode({'username' : username,
        //                                     'password' : password,
        //                                     'client' : 'referer',
        //                                     'referer': "https://arcgis-itconsulting.idom.com/portal/",                                    
        //                                     'expiration': 60,                                    
        //                                     'f' : 'json'});
        // response = urllib.urlopen("https://arcgis-itconsulting.idom.com/portal/" + '/sharing/rest/generateToken?',
        //                                parameters).read()

        
    }

    const logout = () => {
        setLoginPending(false);
        setLoginSuccess(false);
        setLoginError(null);
        Cookies.remove('token');
        localStorage.removeItem("user");
        sessionStorage.setItem('taskId', null);
    }

    const validateCookie = ()=> {
        //console.log("calling validate cookie", Cookies.get('token'));
        if(Cookies.get('token') && window.localStorage.getItem('user')){
            setUser(JSON.parse(window.localStorage.getItem('user')));
            console.log(JSON.parse(window.localStorage.getItem('user')))
            setLoginSuccess(true);

        }
        else setLoginSuccess(false);
    }

    return (
        <AuthContext.Provider
            value={{
                state,
                user,
                login,
                logout,
                validateCookie
            }}
        >
            {props.children}
        </AuthContext.Provider>
    );
};

// // fake login
// const fetchLogin = (email, password, callback) =>
//     setTimeout(async () => {
//         let res = await authAPI.login(email, password);
//         if (res) return callback(null);
//         return callback(new Error('Invalid email and password'));

//         // if (email === 'admin' && password === 'admin') {
//         //     return callback(null);
//         // } else {
//         //     return callback(new Error('Invalid email and password'));
//         // }
//     }, 1000);

export default function useAuth() {
    return useContext(AuthContext);
}